import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Role, RoleType } from "../../models/Role";
import { UserHeader } from "../UserHeader/UserHeader";
import { useApplicationContext } from "../../application/ApplicationContext";
import { activeUser } from "../../services/AuthService";
import "./Header.scss";

interface HeaderProps {
  profileImage?: string;
  name: string;
  role?: Role;
  onNotificationClick: () => void;
  onLogoutClick: () => void;
}

export const Header = (p: HeaderProps) => {
  const { profileImage, name, role, onLogoutClick } = p;

  const { state, businessYearSet } = useApplicationContext();
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();
  const businessYear = state.businessYear ?? currentYear;

  const [yearsMenuActive, setYearsMenuActive] = useState<boolean>(false);

  const canChangeBusinessYear =
    activeUser?.role?.name === RoleType.Administrator ||
    activeUser?.role?.name === RoleType.Superadmin;

  return (
    <div className="header-container">
      <a className="header-logo" href="/">
        <img src="/images/rwa-logo.png" alt="logo" />
      </a>
      <div className="header-user">
        <UserHeader profileImage={profileImage} name={name} role={role} />
      </div>
      <div className="header-buttons">
        {yearsMenuActive && canChangeBusinessYear && (
          <InputNumber
            inputId="businessYear"
            value={businessYear}
            onValueChange={(e) => {
              const newYear = e.value as number;
              businessYearSet(newYear);
            }}
            useGrouping={false}
            showButtons
            min={2020}
            max={new Date().getFullYear()}
          />
        )}
        <div
          onClick={() => {
            if (!canChangeBusinessYear) return;
            setYearsMenuActive(!yearsMenuActive);
          }}
        >
          <div className="header-button-years">
            <i className="bi bi-calendar-check header-icon" />
          </div>
          <div className="header-button-label">{t("Godina")} {`${businessYear}.`}</div>
        </div>
        <div>
          <div className="header-languages">
            <Dropdown
              placeholder=""
              value={i18n.language}
              onChange={(e) => {
                i18n.changeLanguage(e.value);
              }}
              options={[
                { label: "SR", value: "sr" },
                { label: "EN", value: "en" },
              ]}
            />
          </div>
          <div className="header-button-label">{t("Jezik")}</div>
        </div>
        <div className="header-button-settings">
          <div onClick={onLogoutClick}>
            <i className="bi bi-box-arrow-left header-icon" />
          </div>
          <div className="header-button-label">{t("Logout")}</div>
        </div>
      </div>
    </div>
  );
};
